import type * as api from "./api";

export const KEY_STATUS_TEXT: Record<api.ApiKey["status"], string> = { active: "Active", revoked: "Revoked", expired: "Expired" };

const LABEL_MAX = 80;

export function labelProblem(label: string, taken: readonly string[]): string | null {
  const clean = label.trim().replace(/\s+/g, " ");
  if (!clean) return "Enter a name for the key.";
  if (clean.length > LABEL_MAX) return `Use ${LABEL_MAX} characters or fewer.`;
  if (taken.some((other) => other.toLowerCase() === clean.toLowerCase())) return "An active key has this name. Use a different name.";
  return null;
}

/** The end date is the last day that the key works, so today is the earliest date. */
export function endProblem(day: string, today: string): string | null {
  if (!day) return null;
  return day < today ? "The end date is in the past." : null;
}

export function hubsText(hubIds: readonly string[], hubs: readonly api.Hub[]): string {
  if (!hubIds.length) return "All hubs";
  return hubIds.map((id) => hubs.find((hub) => hub.id === id)?.name ?? "Unknown hub").join(", ");
}

/** The last day that the key works: the API keeps the start of the next day in UTC. */
export function lastDay(expiresAt: string | null): string | null {
  if (!expiresAt) return null;
  const end = new Date(expiresAt);
  end.setUTCDate(end.getUTCDate() - 1);
  return end.toISOString().slice(0, 10);
}

export const revokeText = (label: string) => `Revoke key "${label}"? Calls with this key will fail. You cannot undo this.`;
